import { useCampaignPlannerContext } from '@/dashboards/CampaignPlanner/hooks/useCampaignPlannerContext';
import { Button, Modal, Typography } from '@analytical-alley/ui';

export const DeleteCampaignModal = () => {
    const { deleteCandidate, setDeleteCandidate, deleteCampaign } =
        useCampaignPlannerContext();
    const showDialog = !!deleteCandidate;

    const onClose = () => {
        setDeleteCandidate(null);
    };

    return (
        <Modal dismissible show={showDialog} onClose={onClose}>
            <Modal.Header>Delete campaign</Modal.Header>

            <Modal.Body className="text-white">
                <Typography variant="bodyS" className="mb-2">
                    Are you sure you want to delete this campaign?
                </Typography>
            </Modal.Body>

            <Modal.Footer className="py-4">
                <Button
                    className="ml-2"
                    size="sm"
                    color="red"
                    onClick={deleteCampaign}
                >
                    Delete
                </Button>
                <Button
                    className="ml-2"
                    size="sm"
                    color="light"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
